import { computed, ref } from 'vue'
import { DateTime } from 'luxon'
import { getNextOccurrenceDiffFromNow } from '@/helpers/date'

const now = ref(DateTime.utc().toUnixInteger())
setInterval(() => now.value = DateTime.utc().startOf('second').toSeconds(), 1000)

export const useNow = () => {
  return {
    now,
    nowDateHourTimestamp: computed<number>(() => {
      return DateTime.fromSeconds(now.value, { zone: 'utc' }).startOf('hour').toSeconds()
    }),
    nowDateMinuteTimestamp: computed<number>(() => {
      return DateTime.fromSeconds(now.value, { zone: 'utc' }).startOf('minute').toSeconds()
    }),
    nowDateTimestamp: computed<number>(() => {
      return DateTime.fromSeconds(now.value, { zone: 'utc' }).startOf('day').toSeconds()
    }),
    nowDateIso: computed<string>(() => {
      return DateTime.fromSeconds(now.value, { zone: 'utc' }).startOf('day').toISODate()
    }),
    counterToNextDay: computed(() => {
      return Math.floor(
        DateTime.fromSeconds(now.value, { zone: 'utc' })
          .plus({ days: 1 })
          .startOf('day')
          .toSeconds() - now.value,
      )
    }),
    counterToNextWeek: computed(() => {
      return getNextOccurrenceDiffFromNow(DateTime.fromSeconds(now.value, { zone: 'utc' }).plus({ weeks: 1 }).startOf('week').toSeconds(), now.value)
    }),
  }
}
